import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import { reactGAPageview, reactGAEvent, nextFinancingOption } from '../../../../helper';
import {
  changePage,
  mapApplicationToMicrof,
  resetState,
  mapAppToFoundation,
  mapAppToFtl,
} from '../../../../redux/actions/index';
import selectedFinancierEnum from '../../../../assets/js/SelectedFinancierEnum';
import { Link } from 'react-router-dom';
import CustomButton from '../../../../components/UI/Button/CustomButton';
import ApplicationFlowEnum from '../../../../assets/js/ApplicationFlowEnum';
import { MicrofFlowPageNumber } from '../../../Microf/MicrofFlow';

const Declined = props => {
  const {
    user,
    email,
    dealerUserId,
    did,
    dispatchSubmitMindfire,
    dispatchUpdateSelectedFinancier,
    consumerToken,
    history,
    dispatchSetFlow,
    dispatchChangePageTitle,
    application,
    dispatchMapApplicationToMicrof,
    dispatchMapApplicationToFoundation,
    dispatchMapApplicationToFTL,
    dispatchResetState,
    isHomeowner,
    dispatchChangePage,
  } = props;

  useEffect(() => {
    dispatchChangePageTitle('Declined Application');
    reactGAPageview({
      path: '/ca_gsdeclined',
      trackerNames: [],
      title: 'ca_gsdeclined',
      did,
      dealerUserId,
    });
    // eslint-disable-next-line
  }, []);

  let nextFO = nextFinancingOption(application, selectedFinancierEnum.GREENSKY);

  const handleClick = async () => {
    reactGAEvent({
      category: 'Button',
      action: 'Click',
      label: `Continue to ${nextFO.value}`,
      did,
      dealerUserId,
    });
    dispatchSubmitMindfire({
      email: email,
      lastPage: '9026',
      dealerUserId: dealerUserId,
      did: did,
    });

    await dispatchUpdateSelectedFinancier(nextFO.value, consumerToken, () => {
      if (nextFO === selectedFinancierEnum.FOUNDATION) {
        dispatchMapApplicationToFoundation(application);
        dispatchSetFlow(ApplicationFlowEnum.FOUNDATION_FLOW.value);
        history.push(ApplicationFlowEnum.FOUNDATION_FLOW.path);
      } else if (nextFO === selectedFinancierEnum.FTL) {
        dispatchMapApplicationToFTL(application);
        dispatchSetFlow(ApplicationFlowEnum.FTL_FLOW.value);
        history.push(ApplicationFlowEnum.FTL_FLOW.path);
      } else {
        dispatchMapApplicationToMicrof(application);
        dispatchSetFlow(ApplicationFlowEnum.MICROF_FLOW.value);
        dispatchChangePage(MicrofFlowPageNumber.AccountEmail);
        history.push(ApplicationFlowEnum.MICROF_FLOW.path);
      }
    });
  };

  const IsNotHomeownerContent = () => {
    return (
      <>
        <Row className="justify-content-center mt-2">
          <Col xs="auto" sm="8" className="text-center">
            <h5>
              <b>
                You may re-apply with the homeowner as a co-applicant to be considered for
                additional financing and lease purchase offers.
              </b>
            </h5>
          </Col>
        </Row>
        <Row className="justify-content-center mt-5">
          <Col xs="10" md="3">
            <Link
              to={user?.dealerUser ? '/portal/dashboard' : ''}
              onClick={() => !user?.dealerUser && dispatchResetState({})}
              style={{ textDecoration: 'none' }}
              className="block"
            >
              <CustomButton
                color="secondary"
                size="lg"
                block
                type="button"
                title={user?.dealerUser ? 'Return to dashboard' : 'Exit'}
              />
            </Link>
          </Col>
        </Row>
      </>
    );
  };

  const NextFOComponent = () => {
    return (
      <>
        <Row className="justify-content-center mt-2">
          <Col xs="auto" sm="8" className="text-center">
            <h5>
              {nextFO === selectedFinancierEnum.FTL ? (
                <b>
                  But wait! You may still qualify for an FTL financing option. If you would like to
                  apply with FTL, just press "Continue to FTL" and you will be directed to the FTL
                  application process.
                </b>
              ) : (
                <b>
                  But wait! You may still qualify for a lease purchase option. A lease purchase
                  option is different than financing.
                </b>
              )}
            </h5>
          </Col>
        </Row>
        {nextFO === selectedFinancierEnum.MICROF && (
          <>
            <Row className="justify-content-center mt-5">
              <Col xs="auto" className="text-center">
                <h4>Microf Lease Purchase Option</h4>
              </Col>
            </Row>
            <Row className="justify-content-center ">
              <Col xs="auto" sm="8">
                <ul className="microf-lease-purchase-options">
                  <li>
                    Monthly renewals up to 84 months to own.{' '}
                    <p>Not all term options are available in all states.</p>
                  </li>
                  <li>
                    You will own the item after the total of payments to ownership is paid in full
                    or is paid by prepayment.{' '}
                    <p>
                      Save up to 40% or more off your remaining payments to ownership. Early
                      Purchase Options vary by state, so call us at 855-642-7631 for details.
                    </p>
                  </li>
                  <li>
                    Damaged credit? Not a problem!{' '}
                    <p>Microf regularly approves applicants with less than perfect credit.</p>
                  </li>
                </ul>
              </Col>
            </Row>
          </>
        )}
        <Row
          className={
            nextFO === selectedFinancierEnum.MICROF
              ? 'justify-content-center'
              : 'justify-content-center mt-5'
          }
        >
          <Col xs="auto">
            <CustomButton
              color="primary"
              clickHandler={handleClick}
              title={`Continue to ${nextFO.value}`}
            />
          </Col>
        </Row>
      </>
    );
  };

  const ExitBtnComponent = () => {
    return (
      <Row className="justify-content-center mt-2">
        <Col xs="12" md="2">
          <Link
            to={user && user.dealerUser ? '/portal/dashboard' : ''}
            onClick={() => !(user && user.dealerUser) && dispatchResetState({})}
            style={{ textDecoration: 'none' }}
            className="block"
          >
            <CustomButton
              color="secondary"
              size="lg"
              block
              type="button"
              title={user && user.dealerUser ? 'Back to dashboard' : 'Exit'}
            />
          </Link>
        </Col>
      </Row>
    );
  };

  const getComponent = () => {
    if (!isHomeowner) {
      return IsNotHomeownerContent();
    }
    return nextFO ? NextFOComponent() : ExitBtnComponent();
  };

  return (
    <Container>
      <Row className="justify-content-center mt-2">
        <Col xs="auto" sm="8" className="text-center">
          <h5>
            <b>
              GreenSky was unable to approve your credit application at this time. You will receive
              a notification via email within 30 days.
            </b>
          </h5>
        </Col>
      </Row>
      {getComponent()}
    </Container>
  );
};

const mapStateToProps = state => ({
  consumerToken:
    state.softPull.applicationSubmitDTO && state.softPull.applicationSubmitDTO.consumerToken,
  isHomeowner:
    state.softPull.applicationSubmitDTO?.isHomeowner ||
    state.preQualificationInformation?.isHomeowner,
  email: state.preQualificationInformation.email,
  dealerUserId: state.auth.dealerUserId,
  did: state.auth.did,
  user: state.auth.user,
  application: state.softPull.applicationSubmitDTO,
});

const mapDispatchToProps = dispatch => ({
  dispatchChangePage: page => dispatch(changePage(page)),
  dispatchMapApplicationToMicrof: app => dispatch(mapApplicationToMicrof(app)),
  dispatchMapApplicationToFoundation: app => dispatch(mapAppToFoundation(app)),
  dispatchMapApplicationToFTL: app => dispatch(mapAppToFtl(app)),
  dispatchResetState: props => dispatch(resetState(props)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Declined);
